import { get } from "../../../utils/object-helpers";

$ {
    const reviewCount = get(input, "reviewCount", {});
    const reviews = get(input, "reviews", {});
    const reviewsLink = get(reviews, "action.URL", "");
    const accessibilityText = get(reviews, "accessibilityText", "");
    let starCount = get(reviews, "value", null);
    if (starCount) {
        starCount = starCount.toString();
        starCount = starCount.replace(".", "-");
    }
}

<div class="str-product-review">
    <if(starCount)>
        <a href=`${reviewsLink}` aria-label=`${accessibilityText}` class="str-product-review__link">
            <ebay-star-rating value=starCount/>        
        </a>
    </if>
    <str-textual-display ...reviewCount />
</div>
